"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _urlencode = _interopRequireDefault(require("urlencode"));
var _lodash = _interopRequireDefault(require("lodash"));
var _constants = _interopRequireDefault(require("./constants"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MESSAGES = {
  BAD_RESPONSE: _constants.default.ErrorMessageFromServer
};
var RequestUtil = /*#__PURE__*/function () {
  function RequestUtil() {
    var _this = this,
      _ref,
      _ref2,
      _ref3,
      _ref4,
      _ref5,
      _ref6,
      _ref7;
    (0, _classCallCheck2.default)(this, RequestUtil);
    (0, _defineProperty2.default)(this, "options", void 0);
    (0, _defineProperty2.default)(this, "getParam", function (url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var isUrlParam = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return isUrlParam ? _this.buildURLParameters(url, params) : "".concat(url).concat(_this.buildQSParameters(params));
    });
    (0, _defineProperty2.default)(this, "getParambyParamType", function (url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        paramType: null
      };
      switch (options.paramType) {
        case _constants.default.PARAM_TYPE.PATH_VARIABLE:
          return _this.buildURLParameters(url, options.pathVariabel);
        case _constants.default.PARAM_TYPE.QUERY_STRING:
          return "".concat(url).concat(_this.buildQSParameters(options.queryString));
        case _constants.default.PARAM_TYPE.BOTH:
          var newUrl = _this.buildURLParameters(url, options.pathVariabel);
          return "".concat(newUrl).concat(_this.buildQSParameters(options.queryString));
        default:
          return _this.getParam(url, options.params, options.isUrlParam);
      }
    });
    (0, _defineProperty2.default)(this, "initOptions", function () {
      var optionsVals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _objectSpread(_objectSpread({}, optionsVals), {}, {
        credentials: _lodash.default.get(optionsVals, 'credentials', 'include'),
        headers: _this.setHeader(optionsVals)
      });
    });
    (0, _defineProperty2.default)(this, "handleResult", function (_x) {
      return (_ref = _ref || (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(response) {
        var result;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(response.status >= 400)) {
                _context.next = 11;
                break;
              }
              _context.prev = 1;
              _context.next = 4;
              return response.json();
            case 4:
              result = _context.sent;
              return _context.abrupt("return", Promise.reject(result));
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              throw new Error(MESSAGES.BAD_RESPONSE);
            case 11:
              return _context.abrupt("return", response.json());
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 8]]);
      }))).apply(this, arguments);
    });
    (0, _defineProperty2.default)(this, "doRequest", function (_x2) {
      return (_ref2 = _ref2 || (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(url) {
        var options,
          response,
          _args2 = arguments;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              _context2.next = 3;
              return window.fetch(url, options);
            case 3:
              response = _context2.sent;
              return _context2.abrupt("return", _this.handleResult(response));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))).apply(this, arguments);
    });
    (0, _defineProperty2.default)(this, "buildQSParameters", function () {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (_lodash.default.isEmpty(params)) {
        return '';
      }
      var query = Object.keys(params).map(function (k) {
        return "".concat((0, _urlencode.default)(k), "=").concat((0, _urlencode.default)(params[k]));
      }).join('&');
      return "?".concat(query);
    });
    (0, _defineProperty2.default)(this, "buildURLParameters", function (url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (_lodash.default.isEmpty(params)) {
        return '';
      }
      var tempUrl = url;
      Object.keys(params).map(function (k) {
        tempUrl = tempUrl.replace("{".concat(k, "}"), params[k]);
        return tempUrl;
      });
      return tempUrl;
    });
    (0, _defineProperty2.default)(this, "getData", function (_x3) {
      return (_ref3 = _ref3 || (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(url) {
        var options,
          defaultOptions,
          newOptions,
          _args3 = arguments;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
              defaultOptions = {
                method: _constants.default.HTTP_GET
              };
              newOptions = _this.initOptions(options);
              return _context3.abrupt("return", _this.doRequest(_this.getParambyParamType(url, options), Object.assign(newOptions, defaultOptions)));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))).apply(this, arguments);
    });
    (0, _defineProperty2.default)(this, "postData", function (_x4) {
      return (_ref4 = _ref4 || (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(url) {
        var data,
          options,
          defaultOptions,
          newOptions,
          _args4 = arguments;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              data = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
              options = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
              defaultOptions = {
                method: _constants.default.HTTP_POST,
                body: options.isFile ? data : JSON.stringify(data)
              };
              newOptions = _this.initOptions(options);
              return _context4.abrupt("return", _this.doRequest(_this.getParambyParamType(url, options), Object.assign(newOptions, defaultOptions)));
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))).apply(this, arguments);
    });
    (0, _defineProperty2.default)(this, "updateData", function (_x5) {
      return (_ref5 = _ref5 || (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(url) {
        var data,
          options,
          defaultOptions,
          newOptions,
          _args5 = arguments;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              data = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
              options = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
              defaultOptions = {
                method: _constants.default.HTTP_PUT,
                body: JSON.stringify(data)
              };
              newOptions = _this.initOptions(options);
              return _context5.abrupt("return", _this.doRequest(_this.getParambyParamType(url, options), Object.assign(newOptions, defaultOptions)));
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))).apply(this, arguments);
    });
    (0, _defineProperty2.default)(this, "deleteData", function (_x6) {
      return (_ref6 = _ref6 || (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(url) {
        var options,
          data,
          defaultOptions,
          newOptions,
          _args6 = arguments;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              options = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
              data = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : null;
              if (data && Object.keys(data).length > 0) {
                defaultOptions = {
                  method: _constants.default.HTTP_DELETE,
                  body: JSON.stringify(data)
                };
              } else {
                defaultOptions = {
                  method: _constants.default.HTTP_DELETE
                };
              }
              newOptions = _this.initOptions(options);
              return _context6.abrupt("return", _this.doRequest(_this.getParambyParamType(url, options), Object.assign(newOptions, defaultOptions)));
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))).apply(this, arguments);
    });
    (0, _defineProperty2.default)(this, "downloadFile", function (_x7) {
      return (_ref7 = _ref7 || (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(url) {
        var options,
          downloadOption,
          newOptions,
          res,
          disposition,
          filenameRegex,
          matches,
          fileName,
          blob,
          tempUrl,
          link,
          _args7 = arguments;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              options = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
              downloadOption = _objectSpread({
                method: 'GET',
                credentials: 'include'
              }, options);
              newOptions = _this.initOptions(downloadOption);
              _context7.next = 5;
              return window.fetch(_this.getParambyParamType(url, options), newOptions);
            case 5:
              res = _context7.sent;
              if (!(res.status >= 400)) {
                _context7.next = 8;
                break;
              }
              throw new Error(MESSAGES.BAD_RESPONSE);
            case 8:
              disposition = res.headers.get('Content-Disposition');
              filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              matches = filenameRegex.exec(disposition);
              fileName = matches[1].replace(/['"]/g, '');
              _context7.next = 14;
              return res.blob();
            case 14:
              blob = _context7.sent;
              // Create blob link to download
              tempUrl = window.URL.createObjectURL(new Blob([blob], {
                type: blob.type || ''
              }));
              link = document.createElement('a');
              link.href = tempUrl;
              link.download = fileName;
              // Append to html page
              document.body.appendChild(link);
              // Force download
              link.click();
              // Clean up and remove the link
              link.parentNode.removeChild(link);
            case 22:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))).apply(this, arguments);
    });
    this.options = {
      'Accept': _constants.default.APPLICATION_JSON,
      'Content-Type': _constants.default.APPLICATION_JSON
    };
  }
  (0, _createClass2.default)(RequestUtil, [{
    key: "setHeader",
    value: function setHeader(optionVals) {
      if (optionVals.isFile) {
        var defaultOptions = {
          'Accept': _constants.default.APPLICATION_JSON
        };
        return Object.assign(defaultOptions, optionVals.headers);
      } else {
        return Object.assign(this.options, optionVals.headers);
      }
    }
  }]);
  return RequestUtil;
}();
exports.default = RequestUtil;